import { gql } from '@apollo/client';
import {
  StudyUnitCategory,
  StudyUnitInstance,
  StudyUnitType,
  StudyUnitViewDataUnionType,
} from '@mildang/graphql-artifact';

type StudyUnit = {
  isEstimative?: boolean | null;
  viewDatas?: Array<StudyUnitViewDataUnionType>;
  isBlock?: boolean;
  category?: StudyUnitCategory | null;
};

export function getSUIType(studyUnit: StudyUnit | StudyUnitInstance): StudyUnitType | 'BLOCK' {
  if ((studyUnit as unknown as StudyUnit)?.isBlock || studyUnit?.category === 'BLOCK') return 'BLOCK';
  if (studyUnit?.isEstimative) {
    if (studyUnit?.viewDatas?.[0]?.__typename === 'WordTestGroupView') return 'WORD_TEST';
    return 'ESTIMATIVE';
  }
  if (studyUnit?.viewDatas?.[0]?.__typename === 'WordMemorizationGroupView') return 'WORD_MEMORIZATION';
  if (studyUnit?.viewDatas?.[0]?.__typename === 'VideoReadingsGroupView') return 'LEARNING_VIDEO_FIXED';
  return 'LEARNING_NORMAL';
}

export default getSUIType;

gql`
  fragment getSUIType_CustomStudyUnit on CustomStudyUnit {
    id
    isEstimative
    category
    viewDatas {
      __typename
    }
  }
  fragment getSUIType_StudyUnitInstance on StudyUnitInstance {
    id
    isEstimative
    category
    viewDatas {
      __typename
    }
  }
  fragment getSUIType_StudyUnit on StudyUnit {
    id
    isBlock
    isEstimative
    viewDatas {
      __typename
    }
  }
  fragment getSUIType_ReplicaStudyUnit on ReplicaStudyUnit {
    id
    isEstimative
    viewDatas {
      __typename
    }
  }
  fragment getSUIType_StudyUnitInstanceReservation on StudyUnitInstanceReservation {
    isEstimative
  }
  fragment getSUIType_UnitContent on UnitContent {
    id
    isEstimative
    viewDatas {
      __typename
    }
  }
`;
